import { Component } from '@angular/core';
import { UserService } from 'netsocial-posting/src/app/services/user/user.service';

@Component({
  selector: 'app-tour-intro',
  templateUrl: './tour-intro.component.html',
  styleUrls: ['./tour-intro.component.scss'],
})
export class TourIntroComponent {
  modal: HTMLIonModalElement;

  constructor(private userService: UserService) {}

  async getStarted(): Promise<void> {
    await this.modal.dismiss();

    this.userService.startTour({
      tour: this.userService.currentTours[0],
      ownerContextToCache: this.userService.currentOwnerContextInput,
      netSocialAccounts: this.userService.paginatedNetsocialAccounts
        ? this.userService.paginatedNetsocialAccounts.items
        : [],
      changeContextOwner: (owner) => {
        return this.userService.mutContextOwner(owner);
      },
      successCallBack: () => {
        const $gettingStartedButton =
          document.querySelector<HTMLDivElement>('.getting-started-button');
        return $gettingStartedButton?.click();
      },
    });
  }
}
